var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextCategory1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 96,
    viewBox: "0 0 89 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8654 20.5714C86.6894 20.5714 89 18.2571 89 15.4286C89 12.6 86.6894 10.2857 83.8654 10.2857H25.6731V1.71429C25.6731 0.771429 24.9029 0 23.9615 0H17.1154C16.174 0 15.4038 0.771429 15.4038 1.71429V10.2857H5.13462C2.31058 10.2857 0 12.6 0 15.4286C0 18.2571 2.31058 20.5714 5.13462 20.5714H15.4038V92.5714H11.9808C11.0394 92.5714 10.2692 93.3429 10.2692 94.2857C10.2692 95.2286 11.0394 96 11.9808 96H29.0962C30.0375 96 30.8077 95.2286 30.8077 94.2857C30.8077 93.3429 30.0375 92.5714 29.0962 92.5714H25.6731V20.5714H42.7885V27.4286H34.2308C33.2894 27.4286 32.5192 28.2 32.5192 29.1429V46.2857C32.5192 47.2286 33.2894 48 34.2308 48H42.7885V54.8571H34.2308C33.2894 54.8571 32.5192 55.6286 32.5192 56.5714V73.7143C32.5192 74.6571 33.2894 75.4286 34.2308 75.4286H75.3077C75.8212 75.4286 76.3175 75.1886 76.6427 74.7771L83.4888 66.2057C83.9852 65.5714 83.9852 64.6971 83.4888 64.0629L76.6427 55.4914C76.3175 55.08 75.8212 54.84 75.3077 54.84H68.4615V47.9829H75.3077C75.8212 47.9829 76.3175 47.7429 76.6427 47.3314L83.4888 38.76C83.9852 38.1257 83.9852 37.2514 83.4888 36.6171L76.6427 28.0457C76.3175 27.6343 75.8212 27.3943 75.3077 27.3943H68.4615V20.5371H83.8654V20.5714ZM65.0385 54.8571H46.2115V48H65.0385V54.8571ZM65.0385 27.4286H46.2115V20.5714H65.0385V27.4286Z",
    fill: "#C9A662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextCategory1);
export default __webpack_public_path__ + "static/media/next-category1.64d8eb90ff7012d0753ffc1ced8a7b7b.svg";
export { ForwardRef as ReactComponent };